<div class="modal-header align-items-center">
    <h4>Editor de condiciones</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cerrar()"></button>
</div>
<div class="modal-body d-flex flex-column overflow-y">
    <div class="row">
        <div class="col flex-grow-0" *ngIf="operador == null && condicion == null">
            <div ngbDropdown class="d-inline-block">
                <button type="button" class="btn btn-outline-primary dropdown-sin-flecha" id="dropdownOperandos"
                    ngbDropdownToggle>
                    <app-svg-icon icon="plus-lg"></app-svg-icon>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownOperandos">
                    <button ngbDropdownItem *ngFor="let condicion of condiciones" (click)="agregarCondicion(condicion)">
                        Condicion - {{condicion.nombre}}
                    </button>
                    <button ngbDropdownItem *ngFor="let operador of operadores" (click)="agregarOperador(operador)">
                        Operador - {{operador.nombre}}
                    </button>
                </div>
            </div>
        </div>
        <div class="col-12" *ngIf="operador != null || condicion != null">
            <app-operador *ngIf="operador != null" [operador]="operador" [encuesta]="encuesta" [pregunta]="pregunta"
                [item]="item">
            </app-operador>
            <app-condicion *ngIf="condicion != null" [condicion]="condicion" [encuesta]="encuesta"
                [pregunta]="pregunta" [item]="item"></app-condicion>
        </div>
    </div>
</div>
<div class="modal-footer">
    <div class="btn btn-secondary" (click)="cerrar()">Cancelar</div>
    <button class="btn btn-primary" (click)="guardarCondicion()">Guardar</button>
</div>
